import Tabicon from '../TabIcon/TabIcon';
import { filterTabIconTheme } from '../../../utils';
import { SelectorType, TabDesign } from '../types/enums';
import { Theme } from '../../types/enums';
import { TabProps, TabTheme } from './type/propsType';
import styles from './Tab.module.scss';

const Tab = ({
  theme = Theme.BLACK,
  title,
  icon,
  iconStyle,
  selected = false,
  layout,
  design,
  onTabClick,
  selectorType,
  disabled = false,
  className = '',
  ...restProps
}: TabProps) => {
  const updatedSelectorType =
    design === TabDesign.PILL ? SelectorType.CIRCLE : icon ? selectorType : SelectorType.UNDERLINE;
  return (
    <div
      role="presentation"
      onKeyDown={(e) => {
        if (e.key === 'Enter' && !disabled) {
          onTabClick?.();
        }
      }}
      onClick={() => !disabled && onTabClick?.()}
      className={`${styles['tab-container']}  ${styles[theme]} ${
        design === TabDesign.ICON_CIRCLE ? styles[TabDesign.ICON_CIRCLE] : ''
      } ${design === TabDesign.SOLID ? styles[TabDesign.SOLID] : ''} ${disabled ? styles['disabled'] : ''} ${
        design !== TabDesign.ICON_CIRCLE ? styles[updatedSelectorType] : ''
      } ${styles[selected ? 'selected' : '']} ${className}`}
      data-testid="tab-container-test-id"
      {...restProps}
    >
      <div
        className={`${styles['tab-container-icon']} ${styles[layout]} ${disabled ? styles['disabled'] : ''} ${
          styles[icon ? 'tab-title-mobile' : '']
        }`}
      >
        <Tabicon
          design={design}
          icon={icon}
          iconStyle={iconStyle}
          iconClass={styles['icon']}
          theme={theme && filterTabIconTheme(theme)}
          selected={selected as boolean}
          disabled={disabled}
          selectorType={design !== TabDesign.PILL ? updatedSelectorType : SelectorType.UNDERLINE}
        />
        <span className={`${styles['tab-title']} ${selected && !disabled ? styles['selected'] : ''}`}>{title}</span>
      </div>
      {selected && updatedSelectorType === SelectorType.UNDERLINE && (
        <div
          className={`${styles[theme]} ${design === TabDesign.SOLID ? styles[TabDesign.SOLID] : ''} ${
            styles['underline-container']
          }`}
        ></div>
      )}
    </div>
  );
};

export default Tab;
export type { TabTheme };
